import { observer } from 'mobx-react';
import { useRouter } from 'next/router';
import { useBoolean, useSetState } from 'react-hanger';
import { useEffect } from 'react';
import { browser, globalPageConfig, request } from 'lib';
import helpStyle from './static/help.module.scss';
import Head from 'next/head';
import { LoadingBlock, UiToast } from 'components';
const a = helpStyle.a;

const Detail = observer((props) => {
  const noticeId = useRouter().query.id;

  const { enableActionNoticeIds = [] } = globalPageConfig.useConfig();

  const { state: data, setState } = useSetState({});
  const isShowAction = useBoolean(false);

  useEffect(() => {
    if (noticeId) {
      request.api
        .get(`public/notice_one/${noticeId}`, {
          page: 1,
          size: 12,
        })
        .then((res) => {
          setState(res.data);
        });
    }
  }, [noticeId]);

  useEffect(() => {
    const index = enableActionNoticeIds.findIndex((item) => {
      return item == noticeId;
    });
    if (index > -1) {
      isShowAction.setValue(true);
    }
  }, [enableActionNoticeIds, noticeId]);

  if (!data) {
    return <LoadingBlock page></LoadingBlock>;
  }

  const handlePdf = () => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      const element = document.getElementById('j_article');

      element.querySelectorAll('img').forEach((img) => {
        img.width = img.width;
        img.height = img.height;
      });

      const opt = {
        margin: 1,
        filename: `${data.title}.pdf`,
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        image: { type: 'jpeg', quality: 0.8 },
        html2canvas: { scale: 1, allowTaint: true, useCORS: true },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      };

      html2pdf().set(opt).from(element).save();
    }, 200);
  };

  const handleSearch = () => {
    const elements = document.getElementById('j_article').querySelectorAll('p');
    const text = document.getElementById('j_search_text').value.trim();

    if (!text) {
      handleClear();
      return;
    }
    elements.forEach((element) => {
      let textToHighlight = element.textContent;
      const regex = new RegExp(text, 'gi'); // 'g' for global, 'i' for case-insensitive
      const highlightedText = textToHighlight.replace(regex, (match) => `<mark>${match}</mark>`);
      element.innerHTML = highlightedText;
    });
  };

  const handleClear = () => {
    const spanTags = Array.from(
      document.getElementById('j_article').querySelectorAll('mark'),
    ).reverse();

    spanTags.forEach((span) => {
      const parent = span.parentNode;
      // 创建文档片段，保存 span 内部的所有子节点
      const fragment = document.createDocumentFragment();
      while (span.firstChild) {
        fragment.appendChild(span.firstChild);
      }
      // 用内部内容替换 span 标签
      parent.replaceChild(fragment, span);
      // 合并相邻的文本节点（可选，优化 DOM 结构）
      parent.normalize();
    });
  };

  const handleFind = () => {
    if (browser.mac) {
      UiToast.text('请按下 Command+F 使用浏览器搜索功能');
    } else {
      UiToast.text('请按下 Ctrl+F 使用浏览器搜索功能');
    }
  };

  return (
    <div className=" container">
      <Head>
        <title>{data.title}_么么直播_美女视频直播秀场</title>
        <script src="https://lib.sumeme.com/base/scripts/??/util/html2pdf.bundle.min.js"></script>
        <meta content="柠檬,客服,明星等级,富豪等级,么么直播" name="keywords" />
        <meta
          content="么么直播的帮助中心，客服联系方式，什么是柠檬、什么是明星等级、什么是富豪等级。"
          name="description"
        />
      </Head>
      <div className="body">
        <div className="body-bd fix">
          {isShowAction.value && (
            <div className="action">
              {/*<input type="text" id="j_search_text" className="form-input" />
            <button className="btn btn-outline-default" onClick={handleSearch}>
              搜索
            </button>
            <button className="btn btn-outline-default" onClick={handleClear}>
              清空
            </button>*/}
              <button className="btn-find" onClick={handleFind}></button>
              <button className="btn-pdf" onClick={handlePdf}></button>
            </div>
          )}
          <div
            className="article"
            id="j_article"
            dangerouslySetInnerHTML={{ __html: data.content }}
          ></div>
        </div>
      </div>
    </div>
  );
});

export default Detail;
